import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaAngleDoubleUp } from "react-icons/fa";

const ScrollTop = () => {
  const [showButton, setShowButton] = useState(false);
  const location = useLocation();

  // Show or hide the button based on the scroll position
  const handleScroll = () => {
    if (window.pageYOffset > 300) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  // Scroll the page to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Scroll to top on page change (when location changes)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  // Listen for scroll events
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* Back to Top Button */}
      {showButton && (
        <div>
          <button
            onClick={scrollToTop}
            className="fixed bottom-10 right-10 sm:bottom-20 sm:right-2.5 text-mainColor hover:text-white text-3xl p-2 rounded-2xl shadow-lg transition-opacity duration-300 hover:bg-thirdColor"
            style={{ zIndex: 1000 }}
          >
            <FaAngleDoubleUp />
          </button>
        </div>
      )}
    </>
  );
};

export default ScrollTop;
